import { useContext } from "react";
import ImpersonationContext from "./impersonation-context";

const useImpersonation = () => {
  const context = useContext(ImpersonationContext);

  if (!context) {
    throw new Error(
      "useImpersonation must be used within ImpersonationProvider",
    );
  }

  return context;
};

export default useImpersonation;
